(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39175],{

/***/ 80658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview",
      function () {
        return __webpack_require__(34881);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PrismicClientLegacy": function() { return /* binding */ PrismicClientLegacy; },
/* harmony export */   "PrismicGateway": function() { return /* binding */ PrismicGateway; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prismic_javascript__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63179);
/* harmony import */ var _app_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26532);
/* harmony import */ var _hoa_schema__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34036);










//  - Implementation of legacy prismic to be able to have preview since docs request next 13
var PrismicClientLegacy = function() {
    var req = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return prismic_javascript__WEBPACK_IMPORTED_MODULE_4__/* ["default"].client */ .Z.client(_app_config__WEBPACK_IMPORTED_MODULE_5__/* .apiEndpoint */ ._d || "", createClientOptions(req, _app_config__WEBPACK_IMPORTED_MODULE_5__/* .accessToken */ .To));
};
var createClientOptions = function() {
    var req = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, prismicAccessToken = arguments.length > 1 ? arguments[1] : void 0;
    var reqOption = req ? {
        req: req
    } : {};
    var accessTokenOption = prismicAccessToken ? {
        accessToken: prismicAccessToken
    } : {};
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, reqOption, accessTokenOption);
};
var getMethod = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(fragment, value, options) {
        return _home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return PrismicClientLegacy().query(prismic_javascript__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Predicates.at */ .Z.Predicates.at(fragment, value), options);
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMethod(fragment, value, options) {
        return _ref.apply(this, arguments);
    };
}();
var PrismicGateway = {
    get: getMethod
};
var linkResolver = function(doc) {
    console.log("doc", doc);
    if (doc.type === "offer_page") {
        return "/".concat(doc.lang.slice(0, 2), "/services/").concat(doc.uid);
    }
    if (doc.type === "category_page") {
        // @ts-ignore
        return "/".concat(doc.lang.slice(0, 2), "/").concat(_hoa_schema__WEBPACK_IMPORTED_MODULE_6__/* .TradeUrlSchema */ .c[doc.lang.slice(0, 2)][doc.uid]);
    }
    if (doc.type === "page") {
        return "/".concat(doc.lang.slice(0, 2), "/service/").concat(doc.uid);
    }
    return "/".concat(doc.uid);
};
var Preview = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var _query = router.query, ref = _query.token, documentId = _query.documentId;
        if (ref && documentId) {
            localStorage.setItem("previewToken", ref);
            PrismicClientLegacy().getPreviewResolver(ref, documentId).resolve(linkResolver, "/").then(function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
                    return _home_runner_work_jaimy_monorepo_jaimy_monorepo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return router.push("".concat(url, "?preview=true"));
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(url) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("section", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("title", {
                        children: "Prismic Preview"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("main", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("h1", {
                        children: "Preview"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
                        children: "Waiting for redirect"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Preview);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63179,49774,92888,40179], function() { return __webpack_exec__(80658); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);